// extracted by mini-css-extract-plugin
module.exports = {"title":"Index_title__3KXjW","link":"Index_link__3gjwD"};